import { Flex, FlexProps, Graphic, Stack, Text } from '@thirstycamel/ui'
import React, { forwardRef } from 'react'
import { useUser } from '../../hooks/useUser'

export interface MainHeadNavLoggedInProps extends FlexProps {}

export const MainHeadNavLoggedIn = forwardRef(
  ({ id, ...restProps }: MainHeadNavLoggedInProps, ref) => {
    const { user } = useUser()

    return (
      <Flex align="center" pl={[, , 4]} h={['64px', '86px']} ref={ref} {...restProps}>
        <Stack spacing={0} display={['none', , 'block']}>
          <Text fontWeight="medium">Hi, {user?.firstName}</Text>
        </Stack>

        <Graphic
          name="humpClubLogo"
          size={['64px', '84px', '140px']}
          transform="rotate(10deg)"
          id={id}
          mt={2}
        />
      </Flex>
    )
  },
)

export default MainHeadNavLoggedIn
